import React, { FC } from 'react';
import { TablesNames } from '../../store/tables/tables-context';
import { Title } from '../developers/page-components/Title';
import { Table } from '../table/Table';
import { useMerchants } from '../../store/merchnts/merchants-context';

export const InactiveConfigurationHistory: FC = () => {
	const { merchantState: { fundsReserveConfigInActiveListData, isFundsReserveConfigInactiveListDataLoading }, dispatch } = useMerchants();
	return (
		<div className="mt-5">
			<Table
				name={TablesNames.fundsReserveConfigInactive}
				data={fundsReserveConfigInActiveListData || []}
				isLoading={isFundsReserveConfigInactiveListDataLoading}
				toolbarCustomAction={
					<Title title='Inactive Configurations History' additionalClass='fs-4 ms-2'/>
				}
			/>
		</div>
	);
};